<template>
    <div>                 
        <draggable class="vx-row" group="people" @start="drag = true" @end="onEnd">            
            <div class="vx-col md:w-1/2 w-full mb-8">        
                <vue-resizable class="resizable-content" :min-width="minW | checkEmpty" :min-height="minH | checkEmpty">
                    <vx-card class="drag-demo">
                        <h2>Resize Card 1 <feather-icon icon="MoveIcon" class="float-right"></feather-icon></h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                    </vx-card>
                </vue-resizable>
            </div>            
            <div class="vx-col md:w-1/2 w-full mb-8"> 
                <vue-resizable class="resizable-content" :min-width="minW | checkEmpty" :min-height="minH | checkEmpty">
                    <vx-card class="drag-demo">
                        <h2 >Resize Card 2 <feather-icon icon="MoveIcon" class="float-right"></feather-icon></h2>
                        <vs-table  class="mt-4">
                            <template slot="thead">                                            
                                <vs-th>First Name</vs-th>
                                <vs-th>Last Name</vs-th>
                                <vs-th>OCCUPATION</vs-th>                            
                            </template>
                            <template>
                                <vs-tr>
                                    <vs-td> Himani </vs-td>
                                    <vs-td> Darji </vs-td>
                                    <vs-td> Job </vs-td>                                
                                </vs-tr>
                                <vs-tr>
                                    <vs-td> Dharti </vs-td>
                                    <vs-td> Patel </vs-td>
                                    <vs-td> Business </vs-td>                                
                                </vs-tr>
                                <vs-tr>
                                    <vs-td> Avni </vs-td>
                                    <vs-td> Sindhav </vs-td>
                                    <vs-td> Business </vs-td>                                
                                </vs-tr>
                            </template>
                        </vs-table>                    
                    </vx-card>
                </vue-resizable>
            </div>
            <div class="vx-col md:w-1/2 w-full mb-8">
                <vue-resizable class="resizable-content" :min-width="minW | checkEmpty" :min-height="minH | checkEmpty">    
                    <vx-card class="drag-demo">
                        <h2 >Resize Card 3 <feather-icon icon="MoveIcon" class="float-right"></feather-icon></h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. </p>
                    </vx-card>
                </vue-resizable>
            </div>
            <div class="vx-col md:w-1/2 w-full mb-8">
                <vue-resizable class="resizable-content" :min-width="minW | checkEmpty" :min-height="minH | checkEmpty">
                    <vx-card class="drag-demo">
                        <h2 >Resize Card 4 <feather-icon icon="MoveIcon" class="float-right"></feather-icon></h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                    </vx-card>
                </vue-resizable>
            </div>
        </draggable>   
    </div>      
</template>

<script>
import VxCard from "@/components/vx-card/VxCard";
import VueResizable from 'vue-resizable'
//Drag drop
import draggable from "vuedraggable";
export default {
    components: {
        VxCard,    
        draggable,
        VueResizable
    },
    data() {    
        return {           
            minW: 150,
            minH: 150,
        }
    },
    methods: {    
        /* Drag */
        onEnd(evt) {
            console.log(evt);
        }, 
    }
};
</script>

